import { send } from "@/utils/socket";

export function request(computers) {
  const macAddresses = getMacAddresss(computers);
  if (macAddresses.length != 0) {
    send("command", {
      computerUIDs: [],
      data: {
        macAddresses: macAddresses,
      },
      name: "request",
      eventString: "WOLRequest",
    });
    return true;
  }

  return false;
}

function getMacAddresss(computers) {
  return computers
    .map((x) =>
      x.systemInfo &&
      x.systemInfo.macAddresses &&
      x.systemInfo.macAddresses.length != 0
        ? x.systemInfo.macAddresses
        : null
    )
    .filter((x) => x)
    .flat();
}
